import { useEffect, useRef, useState } from 'react';
import { Link, Text } from '@tiendanube/components';
import { DuplicateIcon } from '@tiendanube/icons';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

import './ApplyValuesToAllVariants.scss';

interface ApplyValuesToAllVariantsProps {
  value?: string | number;
  onChange: () => void;
  onChangeVisibility?: (show: boolean) => void;
  valueWasManuallyChanged?: boolean;
}

function ApplyValuesToAllVariants({
  value,
  onChange,
  onChangeVisibility,
  valueWasManuallyChanged = true,
}: Readonly<ApplyValuesToAllVariantsProps>) {
  const t = useTranslationCatalog();
  const changedValue = useRef(value);
  const [show, setShow] = useState(false);

  const handleClick = () => {
    onChange();
    setShow(false);
    onChangeVisibility?.(false);
  };

  useEffect(() => {
    const isVisible = valueWasManuallyChanged && changedValue.current !== value;
    let timeOut;
    if (isVisible) {
      setShow(true);
      onChangeVisibility?.(true);
      timeOut = setTimeout(() => {
        setShow(false);
        onChangeVisibility?.(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timeOut);
      setShow(false);
      onChangeVisibility?.(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, valueWasManuallyChanged]);

  if (!show) return null;

  return (
    <div className="stratus--apply-to-all-variants">
      <Link appearance="primary" onClick={handleClick}>
        <Text size="caption" appearance="primary">
          <DuplicateIcon /> {t('products.variants.applyValuesToAll')}
        </Text>
      </Link>
    </div>
  );
}

export default ApplyValuesToAllVariants;
